import { Link } from 'react-router-dom';
import Navigation from './components/Navigation';
import SEO from './components/SEO';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#0a1628] text-white">
      <SEO title="Page not found" description="The page you requested does not exist." url="https://www.greyfielddata.com/404" noIndex />
      <Navigation />
      <main className="mx-auto flex min-h-screen max-w-3xl flex-col justify-center px-6 py-32">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-300">404</p>
        <h1 className="mt-4 text-5xl font-semibold leading-[1.08] tracking-tight md:text-7xl">That page is not here.</h1>
        <p className="mt-6 max-w-xl text-xl leading-relaxed text-gray-300">The link may be old, or the address may have a typo. Try the home page or the articles.</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/" className="rounded-xl bg-white px-6 py-3 font-semibold text-[#0a1628]">Go home</Link>
          <Link to="/blog" className="rounded-xl border border-white/15 px-6 py-3 font-semibold text-white">Read the articles</Link>
        </div>
      </main>
    </div>
  );
}
